import { useBrPageContext } from '../context/context.js';

const useBloomreachPageModels = ()=>{
    const page = useBrPageContext();
    return page === null || page === void 0 ? void 0 : page.getComponent().getModels();
};

export { useBloomreachPageModels };
//# sourceMappingURL=use-bloomreach-page-models.js.map
